import type { DetailConfig, InstallationType } from "types/device.types"
import { customInputOf } from "types/device.types"

import InstalledAtInput from "./InstalledAtInput"
import PowerlineAutocomplete from "./PowerlineAutocomplete"
import TowerAutocomplete from "./TowerAutocomplete"
import SpanAutocomplete from "./SpanAutocomplete"

export const INSTALLATION_TYPE_OPTIONS = [
  { value: "powerline", label: "entities.POWERLINE" },
  { value: "tower", label: "entities.TOWER" },
]

export const ORIENTATION_OPTIONS = [
  { value: "clockwise", label: "device_installation.CLOCKWISE" },
  { value: "counterclockwise", label: "device_installation.COUNTERCLOCKWISE" },
]

export const DETAILS_CONFIG: Record<InstallationType, DetailConfig[]> = {
  powerline: [
    {
      name: "installationType",
      labelKey: "device_installation.INSTALLATION_TYPE",
      type: "select",
      selectOptions: INSTALLATION_TYPE_OPTIONS,
      isTranslatable: true,
    },
    {
      name: "installedAt",
      labelKey: "device_information.INSTALLED_AT",
      customInput: InstalledAtInput,
    },
    {
      name: "powerlineId",
      labelKey: "device_installation.POWERLINE",
      customInput: customInputOf(PowerlineAutocomplete),
      placeholder: "device_installation.SELECT_POWERLINE",
    },
    {
      name: "towerAId",
      labelKey: "device_installation.TOWER_N",
      labelOptions: { reference: "A" },
      customInput: customInputOf(TowerAutocomplete),
      placeholder: "device_installation.SELECT_CLOSEST_TOWER",
      type: "number",
    },
    {
      name: "towerBId",
      labelKey: "device_installation.TOWER_N",
      labelOptions: { reference: "B" },
      customInput: customInputOf(TowerAutocomplete),
      placeholder: "device_installation.SELECT_FURTHEST_TOWER",
    },
    {
      name: "spanId",
      labelKey: "device_installation.SPAN",
      customInput: customInputOf(SpanAutocomplete),
      placeholder: "device_installation.SELECT_CORRESPONDING_SPAN",
    },

    {
      name: "orientation",
      labelKey: "device_installation.ORIENTATION",
      type: "select",
      selectOptions: ORIENTATION_OPTIONS,
      isTranslatable: true,
    },
    {
      name: "anchoringPointDistance",
      labelKey: "device_installation.ANCHORING_POINT_DISTANCE",
      type: "number",
    },

    { name: "phaseId", labelKey: "device_installation.PHASE", readOnly: true },
  ],
  tower: [
    {
      name: "installationType",
      labelKey: "device_installation.INSTALLATION_TYPE",
      type: "select",
      selectOptions: INSTALLATION_TYPE_OPTIONS,
      isTranslatable: true,
    },
    {
      name: "installedAt",
      labelKey: "device_information.INSTALLED_AT",
      customInput: InstalledAtInput,
    },
    {
      name: "powerlineId",
      labelKey: "device_installation.POWERLINE",
      customInput: customInputOf(PowerlineAutocomplete),
      placeholder: "device_installation.SELECT_POWERLINE",
    },
    {
      name: "towerId",
      labelKey: "device_installation.TOWER",
      customInput: customInputOf(TowerAutocomplete),
      placeholder: "device_installation.SELECT_TOWER",
    },
  ],
  uninstalled: [
    {
      name: "installationType",
      labelKey: "device_installation.INSTALLATION_TYPE",
      type: "select",
      selectOptions: INSTALLATION_TYPE_OPTIONS,
      isTranslatable: true,
    },
  ],
}
